/* POSH — ملاحظة مقاس 60 خارج الكويت:
   المقاس متاح للبيع عادي، وبيتشحن من مخزن الكويت، فبنكتب ده للعميل بوضوح
   بدل ما نقفل الزرار أو نقول "نفدت الكمية". */
(function () {
  'use strict';

  var KW_ONLY = ['60'];
  var NOTE = '🇰🇼 مقاس 60 يُشحن من مخزن الكويت · التوصيل 3–5 أيام عمل';

  function country() { return (window.Shopify && window.Shopify.country) || 'KW'; }
  if (country() === 'KW') return;

  function txt(el) { return (el && el.textContent || '').trim(); }
  function isKwOnly(el) { return KW_ONLY.indexOf(txt(el).split(/\\s/)[0]) > -1; }
  function isOn(el) {
    return el.classList.contains('is-active') || el.classList.contains('is-on') ||
      el.getAttribute('aria-checked') === 'true' || el.getAttribute('aria-pressed') === 'true';
  }

  function css() {
    if (document.getElementById('posh-market-css')) return;
    var s = document.createElement('style');
    s.id = 'posh-market-css';
    s.textContent = [
      '.posh-kwnote{margin:12px 0 4px;padding:10px 12px;border-radius:12px;background:#f3f8f3;border:1px solid #d6e8da;font-size:13px;font-weight:700;line-height:1.75;color:#2f3d33;text-align:start}'
    ].join('');
    document.head.appendChild(s);
  }

  function note(id) {
    var n = document.createElement('div');
    n.className = 'posh-kwnote';
    n.dataset.poshKwnote = id;
    n.textContent = NOTE;
    return n;
  }

  function product() {
    var info = document.querySelector('.posh-pd__info');
    if (!info) return;
    var chips = info.querySelectorAll('.posh-chip');
    var active = null;
    chips.forEach(function (c) { if (isOn(c)) active = c; });
    var show = !!(active && isKwOnly(active));

    var old = info.querySelector('[data-posh-kwnote="pd"]');
    var host = chips.length ? chips[chips.length - 1].parentElement : null;
    if (show && host && !old) host.insertAdjacentElement('afterend', note('pd'));
    if (!show && old) old.remove();
  }

  var busy = false;
  function run() {
    if (busy) return;
    busy = true;
    try { css(); product(); } catch (e) {}
    busy = false;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('click', function () { setTimeout(run, 80); }, true);
  var t = null;
  new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () { t = null; run(); }, 200);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
  document.addEventListener('shopify:section:load', run);
})();